<template>
  <Container :list="$route.query.title === '名师风采' ? this.$nav21 : this.$nav22"
             :title="$route.query.title" v-if="isMaxScreen" >
    <div id="article_pc">
        <div class="breadcrumb">
        <router-link to="/" class="breadcrumb-item">
          首页
        </router-link>
        <!-- -
        <span @click="back" class="breadcrumb-item">学校简介</span>        -->
        -
        <span @click="$router.go(-1)" class="breadcrumb-item"
               v-if="$route.query.ids == 0">{{$route.query.title}}</span>
        -
        <span class="breadcrumb-item">详情</span>
      </div>
      <div class="article_title">{{home.name}}</div>
      <div class="content" v-html="home.intro"></div>
      <div class="content" v-if="home.intro == ''">暂无数据...</div>
    </div>
  </Container>

  <SzDetailsH5 v-else :home='home'/>
</template>

<script>
import Container from '@/components/Container/index'
import { mapState } from 'vuex'
import SzDetailsH5 from '@/views/app/szDetails/index'
export default {
  name: 'Details',
  components: { Container, SzDetailsH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      tit: '',
      home: {}
    }
  },
  watch: {
    screenWidth: function (val) {
      // 监听屏幕宽度变化
      // console.log("val",val)
      this.isMaxScreen = val > 850
      // alert('ppp')
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.sidebar
    }),
    ...mapState({
      ids: state => state.ids
    })
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  created () {
    this.getDetail()
  },

  methods: {
    async getDetail () {
      const data = await this.$get('/ow/character/' + this.$route.query.id)
      this.home = data
    }
  }
}
</script>

<style scoped lang="scss">
#article_pc {
   width: 100%;
  .article_title{
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 12px;
    text-align: center;
  }

  .content{
    font-size: 16px;
    // text-indent: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    ::v-deep p {
      line-height: 2!important;
    }
    ::v-deep img, ::v-deep video {
      display: block;
      margin: 0 auto;
      max-width: 100%!important;
      height: auto!important;
    }
  }
}

</style>
